/* ===== AZZARI CRO components for Dawn ===== */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function formatMoney(cents, format) {
    const fmt = format || (window.azMoneyFormat || '{{amount_no_decimals}} RSD');
    const value = cents / 100;
    let out;
    if (fmt.includes('amount_no_decimals_with_comma_separator')) out = Math.round(value).toLocaleString('de-DE');
    else if (fmt.includes('amount_no_decimals')) out = Math.round(value).toLocaleString('en-US');
    else if (fmt.includes('amount_with_comma_separator')) out = value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    else out = value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, out);
  }

  /* ---------- Bundle / offer picker ---------- */
  class AzBundle extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.formId = this.dataset.form;
      this.variants = JSON.parse(this.querySelector('[data-az-variants]').textContent);
      this.moneyFormat = this.dataset.moneyFormat;
      this.radios = [...this.querySelectorAll('input[type="radio"]')];
      this.hiddenQty = this.querySelector('input[name="quantity"]');

      this.radios.forEach((r) => r.addEventListener('change', () => this.apply()));

      // keep prices in sync with variant changes (Dawn pub/sub)
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
        this.unsub = subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
          if (!e || !e.data || e.data.sectionId !== this.sectionId) return;
          this.currentVariantId = e.data.variant ? e.data.variant.id : null;
          this.renderPrices();
          this.apply();
        });
      }
      this.currentVariantId = this.getFormVariantId();
      this.renderPrices();
      this.apply();
    }
    disconnectedCallback() { if (this.unsub) this.unsub(); }

    getFormVariantId() {
      const form = document.getElementById(this.formId);
      const input = form && form.querySelector('input[name="id"]');
      return input && input.value ? Number(input.value) : (this.variants[0] && this.variants[0].id);
    }
    getVariant() {
      return this.variants.find((v) => v.id === Number(this.currentVariantId)) || this.variants[0];
    }
    renderPrices() {
      const v = this.getVariant();
      if (!v) return;
      this.querySelectorAll('.az-bundle__item').forEach((item) => {
        const qty = Number(item.dataset.qty) || 1;
        const discountPct = Number(item.dataset.discount) || 0;
        const base = v.price * qty;
        const price = Math.round(base * (1 - discountPct / 100));
        // compare: explicit compare_at × qty, else base price when a % discount is set
        let compare = v.compare_at_price ? v.compare_at_price * qty : (discountPct > 0 ? base : 0);
        const priceEl = item.querySelector('.az-bundle__price');
        const cmpEl = item.querySelector('.az-bundle__compare');
        if (priceEl) priceEl.textContent = formatMoney(price, this.moneyFormat);
        if (cmpEl) {
          if (compare > price) { cmpEl.textContent = formatMoney(compare, this.moneyFormat); cmpEl.hidden = false; }
          else cmpEl.hidden = true;
        }
        const capEl = item.querySelector('[data-az-caption]');
        if (capEl && capEl.dataset.azCaption.includes('[saved]')) {
          const saved = compare > price ? compare - price : 0;
          capEl.textContent = capEl.dataset.azCaption.replace('[saved]', formatMoney(saved, this.moneyFormat));
        }
      });
    }
    apply() {
      const checked = this.radios.find((r) => r.checked) || this.radios[0];
      if (!checked) return;
      const qty = Number(checked.value) || 1;
      // 1) hidden qty in this widget (when theme has no quantity selector)
      if (this.hiddenQty) this.hiddenQty.value = qty;
      // 2) Dawn's visible quantity input, if present
      const section = this.closest('.shopify-section') || document;
      const qtyInput = section.querySelector('.quantity__input');
      if (qtyInput) { qtyInput.value = qty; qtyInput.dispatchEvent(new Event('change', { bubbles: true })); }
      // 3) sticky bar price
      document.dispatchEvent(new CustomEvent('az:bundle', { detail: { qty, sectionId: this.sectionId } }));
    }
  }
  if (!customElements.get('az-bundle')) customElements.define('az-bundle', AzBundle);

  /* ---------- Sticky ATC ---------- */
  class AzSticky extends HTMLElement {
    connectedCallback() {
      this.btn = this.querySelector('[data-az-sticky-submit]');
      this.priceEl = this.querySelector('[data-az-sticky-price]');
      this.mainSection = document.querySelector('product-info');
      this.target = this.mainSection && (this.mainSection.querySelector('.product-form__submit') || this.mainSection);
      if (!this.target) return;

      const io = new IntersectionObserver((entries) => {
        const e = entries[0];
        // show when ATC scrolled above the viewport
        const above = !e.isIntersecting && e.boundingClientRect.top < 0;
        this.classList.toggle('is-visible', above);
      }, { threshold: 0 });
      io.observe(this.target);

      this.btn && this.btn.addEventListener('click', () => {
        const form = this.mainSection.querySelector('form[id^="product-form-"]');
        if (!form) return;
        if (this.dataset.mode === 'scroll') {
          this.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          form.requestSubmit ? form.requestSubmit() : form.submit();
        }
      });

      const sync = () => {
        const p = this.mainSection.querySelector('.price__container .price-item--sale.price-item--last, .price__container .price-item--regular');
        const s = this.mainSection.querySelector('.price__sale .price-item--regular');
        if (p && this.priceEl) {
          this.priceEl.innerHTML = (s && s.textContent.trim() ? '<s>' + s.textContent.trim() + '</s> ' : '') + '<b>' + p.textContent.trim() + '</b>';
        }
      };
      sync();
      if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(sync, 50));
    }
  }
  if (!customElements.get('az-sticky-atc')) customElements.define('az-sticky-atc', AzSticky);

  /* ---------- Before / After ---------- */
  class AzCompare extends HTMLElement {
    connectedCallback() {
      const range = this.querySelector('input[type="range"]');
      if (!range) return;
      const set = (v) => this.style.setProperty('--az-pos', v + '%');
      set(range.value);
      range.addEventListener('input', () => set(range.value));
    }
  }
  if (!customElements.get('az-compare')) customElements.define('az-compare', AzCompare);

  /* ---------- Video carousel ---------- */
  class AzVideos extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.az-videos__track');
      const videos = [...this.querySelectorAll('video')];
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          const v = en.target;
          if (en.isIntersecting) { v.play().catch(() => {}); } else { v.pause(); }
        });
      }, { threshold: 0.5 });
      videos.forEach((v) => io.observe(v));

      this.querySelectorAll('.az-videos__mute').forEach((b) => {
        b.addEventListener('click', () => {
          const v = b.parentElement.querySelector('video');
          const wasMuted = v.muted;
          videos.forEach((o) => { o.muted = true; o.parentElement.classList.remove('is-unmuted'); });
          v.muted = !wasMuted;
          v.parentElement.classList.toggle('is-unmuted', !v.muted);
          if (!v.muted) v.play().catch(() => {});
        });
      });
      const step = () => (this.track.querySelector('.az-videos__item')?.getBoundingClientRect().width || 240) + 12;
      this.querySelector('[data-az-prev]')?.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      this.querySelector('[data-az-next]')?.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
    }
  }
  if (!customElements.get('az-videos')) customElements.define('az-videos', AzVideos);
})();
